module.exports = __webpack_public_path__ + "img/m-banner-cookagaw-de-DE.1f4edd45.jpg";